import { Navigate, useLocation, useParams } from "react-router-dom";

/** Old bookmarks: `/manufacturing/incoming-sales-orders` → `/manufacturing-management/incoming-orders`. */
export function RedirectLegacyIncomingSalesOrders() {
  return <Navigate to="/manufacturing-management/incoming-orders" replace />;
}

/** Old bookmarks under `/manufacturing/cm-po/...` (including nested default routes). */
export function RedirectLegacyManufacturingCmPo() {
  const location = useLocation();
  const tail = location.pathname.replace(/^\/manufacturing\/cm-po\/?/, "");
  const pathname =
    tail === "" || tail === "/"
      ? "/manufacturing-management/cm-po"
      : `/manufacturing-management/cm-po/${tail.replace(/^\//, "")}`;
  return <Navigate to={`${pathname}${location.search}`} replace />;
}

export function RedirectLegacyManufacturingAlternates() {
  const location = useLocation();
  return <Navigate to={{ pathname: "/manufacturing-management/alternates", search: location.search }} replace />;
}

export function RedirectLegacyManufacturingProductionCalendar() {
  const location = useLocation();
  return (
    <Navigate
      to={{ pathname: "/manufacturing-management/production-calendar", search: location.search }}
      replace
    />
  );
}

export function RedirectLegacyManufacturingReporting() {
  const location = useLocation();
  return <Navigate to={{ pathname: "/manufacturing-management/reporting", search: location.search }} replace />;
}

/** Old bookmarks: `/manufacturing/work-orders` → `/manufacturing-management/work-orders`. */
export function RedirectLegacyManufacturingWorkOrders() {
  const location = useLocation();
  return (
    <Navigate
      to={{ pathname: "/manufacturing-management/work-orders", search: location.search }}
      replace
    />
  );
}

/** Old Inside Sales Rep assignment browse → Manufacturing management sales order details. */
export function RedirectInsideSalesRepAssignment() {
  const location = useLocation();
  const { salesOrderId } = useParams();
  if (salesOrderId != null && salesOrderId.trim() !== "") {
    return (
      <Navigate
        to={{
          pathname: `/manufacturing-management/sales-order-details/${encodeURIComponent(salesOrderId)}`,
          search: location.search,
        }}
        replace
      />
    );
  }
  return (
    <Navigate to={{ pathname: "/manufacturing-management/sales-order-details", search: location.search }} replace />
  );
}

/** Old bookmarks: `/manufacturing/settings` → `/manufacturing-management/settings` (hash preserved). */
export function RedirectLegacyManufacturingSettings() {
  const location = useLocation();
  return (
    <Navigate
      to={{
        pathname: "/manufacturing-management/settings",
        search: location.search,
        hash: location.hash,
      }}
      replace
    />
  );
}
